var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('router-link',{staticClass:"overlay-absolute",attrs:{"to":_vm.to}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }